import { create } from "zustand";

interface ThemeState {
  darkMode: boolean;
  setDarkMode: (value: boolean) => void;
  toggleDarkMode: () => void;
}

const getInitialDarkMode = (): boolean => {
  if (typeof window === "undefined") return false;
  return localStorage.getItem("theme") === "dark";
};

const applyDarkModeClass = (value: boolean) => {
  if (typeof window === "undefined") return;
  document.documentElement.classList.toggle("dark-mode", value);
  document.body.classList.toggle("dark-mode", value);
};

const initialDarkMode = getInitialDarkMode();
applyDarkModeClass(initialDarkMode);

const useThemeStore = create<ThemeState>((set) => ({
  darkMode: initialDarkMode,
  setDarkMode: (value) => {
    if (typeof window !== "undefined") {
      localStorage.setItem("theme", value ? "dark" : "light");
      applyDarkModeClass(value);
    }
    set({ darkMode: value });
  },
  toggleDarkMode: () =>
    set((state) => {
      const newValue = !state.darkMode;
      if (typeof window !== "undefined") {
        localStorage.setItem("theme", newValue ? "dark" : "light");
        applyDarkModeClass(newValue);
      }
      return { darkMode: newValue };
    }),
}));

export default useThemeStore;
